import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { WindowService } from 'shared/services/window/window.service';

@Component({
  selector: 'assisted-browsing-frame',
  templateUrl: './assisted-browsing-frame.component.html',
  styleUrls: ['./assisted-browsing-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AssistedBrowsingFrameComponent implements OnInit, OnDestroy {
  @Input()
  public pageViewId: string;

  private _currentOrigin: string;
  private _iframeLoaded = false;
  private _messageBuffer = new Set<any>();
  private readonly _messageListener;

  public frameIsInSyncMode = true;

  @ViewChild('abFrame', { static: true }) abFrame: ElementRef;

  constructor(private _changeDetectorRef: ChangeDetectorRef, private $window: WindowService) {
    this._messageListener = (event: MessageEvent) => this._receiveMessageFromIframe(event);
  }

  ngOnInit(): void {
    this.$window.addEventListener('message', this._messageListener); // eslint-disable-line -- Event source is validated
  }

  ngOnDestroy(): void {
    this.$window.removeEventListener('message', this._messageListener);
  }

  setUrl(url: string): void {
    this._currentOrigin = new URL(url).origin;
    this._iframeLoaded = false;
    this.abFrame.nativeElement.src = url;
  }

  onMessage(data: any): void {
    if (this._iframeLoaded) {
      this._postMessage(data);
    } else {
      this._messageBuffer.add(data);
    }
  }

  onIframeLoaded(): void {
    this._iframeLoaded = true;
    this._postMessage({
      registerListener: true
    });
    for (let data of Array.from(this._messageBuffer.values())) {
      this._postMessage(data);
    }
    this._messageBuffer.clear();
  }

  private _postMessage(data: any): void {
    if (this.frameIsInSyncMode && data && data.method && data.method === 'document') {
      this._onSessionStarted();
    }

    this.abFrame.nativeElement.contentWindow.postMessage(JSON.stringify(data), '*');
  }

  private _receiveMessageFromIframe(event: MessageEvent): void {
    if (this._validateEventSource(event) && event.data === 'started') {
      this._onSessionStarted();
    }
  }

  private _onSessionStarted(): void {
    this.frameIsInSyncMode = false;

    // because of changeDetection is set to OnPush we need to notify angular that we changed a property
    this._changeDetectorRef.markForCheck();
  }

  private _validateEventSource(event: MessageEvent): boolean {
    return event && event.source === this.abFrame.nativeElement.contentWindow && event.origin === this._currentOrigin;
  }
}
